import './Modals.scss';
import { Modal, Typography } from 'antd';
import {
  DeleteOutlined,
  ExclamationCircleOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { ModalProps } from '../../utils/types';

type DeleteConfirmProps = ModalProps & {
  onCancel: () => void;
  onConfirm: () => void;
  message?: string;
  header?: string;
  icon?: string;
};

const iconMap: Record<string, React.ReactNode> = {
  trash: <DeleteOutlined />,
  warning: <WarningOutlined />,
  info: <ExclamationCircleOutlined />,
};

const ConfirmationModal = ({
  isOpen,
  onConfirm,
  onCancel,
  message = 'Are you sure you want to delete this item?',
  header = 'Confirm Deletion',
  icon = 'trash',
}: DeleteConfirmProps) => {
  const headerIcon = iconMap[icon] ?? <ExclamationCircleOutlined />;

  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      onOk={onConfirm}
      title={
        <span className="modal-title">
          {headerIcon}
          <span className="modal-title-text">{header}</span>
        </span>
      }
      okText="Delete"
      cancelText="Cancel"
      okButtonProps={{ danger: true }}
      width={360}
    >
      <Typography.Paragraph>{message}</Typography.Paragraph>
    </Modal>
  );
};

export default ConfirmationModal;
